import getEnvironment from '@square/environment-utils/environment';
import { captureException } from '@sentry/ember';
export function sendErrorToSentry(error) {
  const statusCode = error?.xhrStatus;
  if (isStatusCodeToIgnore(statusCode)) {
    return;
  }
  const environment = getEnvironment();
  if (environment.isProduction || environment.isStaging) {
    captureException(error);
  }
}
export function isStatusCodeToIgnore(statusCode) {
  if (!statusCode) {
    return true;
  }
  const errorStatusCodeToIgnore = [401, 403, 408];
  return statusCode < 400 || statusCode >= 500 || errorStatusCodeToIgnore.includes(statusCode);
}